import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom'
import { UserAuth } from './AuthContext'
import { Header } from './Header';

const Emails = () => {
    const navigate = useNavigate()
  const { getUser } = UserAuth()

  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmails = async () => {
      const { data, error } = await supabase
        .from('emails')
        .select('id, name, email, phone, subject, message, created_at')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching emails:', error.message);
        setError('حدث خطأ أثناء تحميل الرسائل.');
      } else {
        setEmails(data);
      }

      setLoading(false);
    };

    fetchEmails();
  }, []);


  
useEffect(() => {
  async function fetchUser() {
    const u = await getUser();
    if (!u) {
      navigate('/login'); 
    } else {
      setUser(u); // Save logged-in user
    }
  }
  fetchUser();
}, []);

  return (
    <section className="py-20 bg-gray-100 min-h-screen">
      <div><Header/></div>
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6 text-center">
          الرسائل المرسلة
        </h2>
        <div className="w-24 h-1 bg-gold-500 mx-auto mb-10"></div>

        {loading && <p className="text-center text-gray-600">جاري التحميل...</p>}
        {error && <p className="text-center text-red-600">{error}</p>}

        {!loading && !error && emails.length === 0 && (
          <p className="text-center text-gray-700">لا توجد رسائل حتى الآن.</p>
        )}

        {!loading && !error && emails.length > 0 && (
          <div className="overflow-x-auto shadow-lg rounded-lg bg-white">
            <table className="min-w-full text-sm text-right text-gray-800">
              <thead className="bg-navy-900 text-white">
                <tr>
                  <th className="px-4 py-3">الاسم</th>
                  <th className="px-4 py-3">البريد الإلكتروني</th>
                  <th className="px-4 py-3">رقم الهاتف</th>
                  <th className="px-4 py-3">الموضوع</th>
                  <th className="px-4 py-3">الرسالة</th>
                  <th className="px-4 py-3">التاريخ</th>
                </tr>
              </thead>
              <tbody>
                {emails.map((email) => (
                  <tr key={email.id} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-3">{email.name}</td>
                    <td className="px-4 py-3">{email.email}</td>
                    <td className="px-4 py-3">{email.phone || '-'}</td>
                    <td className="px-4 py-3">{email.subject}</td>
                    <td className="px-4 py-3">{email.message}</td>
                    <td className="px-4 py-3 text-gray-500">
                      {new Date(email.created_at).toLocaleString('ar-EG')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default Emails;
